import moment from "moment";
import React from "react";

export const CreatedDateColumnFormatter = (cellContent, row) => (
	<span>{moment(row.createdAt).format("DD/MM/YYYY")}</span>
);
